<!-- eslint-disable max-len -->
<template>
  <Stack class="completion-and-thanks">
    <Stack
      gap="4"
      items="center"
    >
      <Title
        class="success-title"
        size="8"
      >
        Client Portal Login
      </Title>
    </Stack>

    <Stack
      gap="2"
    >
      <p class="advisor-message">
        <strong>{{ clientPortalStore.advisorInfo?.name }}</strong> has invited you to access your secure document portal.
      </p>

      <p class="guidance-text">
        Please log in or create an account to get started.
      </p>
    </Stack>

    <!-- Auth Actions -->
    <Button
      v-if="clientPortalStore.clientInfo?.user?.client_has_password"
      variant="primary"
      size="5"
      @click="clientPortalStore.requestLoginRedirect()"
    >
      Log In to Access
    </Button>

    <Button
      v-else
      variant="primary"
      size="5"
      @click="clientPortalStore.handleRedirectToSignup()"
    >
      Set Up Your Account
    </Button>
  </Stack>
</template>

<script setup>
import { watch } from 'vue';
import { Stack, Button, Title } from '@stakeui';
import { useClientPortalStore } from '@frontend/ui/stores/clientPortalStore';

const clientPortalStore = useClientPortalStore();

watch(
    () => clientPortalStore.shouldRedirectLogin,
    should => {
      if (!should) return;

      clientPortalStore.clearLoginRedirect?.();

      const query = new URLSearchParams({
        entity: clientPortalStore.currentEntityId || '',
        advisor: clientPortalStore.advisorSlug || '',
        firm: clientPortalStore.firmSlug || '',
      }).toString();

      window.location.assign(`/account/client-login/?${query}`);
    },
);
</script>

<style scoped>
.completion-and-thanks {
  background-color: #fff;
  max-width: 50rem;
  margin: 0 auto;
  text-align: center;
  padding: 4em 3em;
  border-radius: 2em;
  box-shadow: 0px 32px 32px 0px rgba(0, 0, 0, 0.02), 0px 16px 16px 0px rgba(0, 0, 0, 0.02), 0px 8px 8px 0px rgba(0, 0, 0, 0.02), 0px 4px 4px 0px rgba(0, 0, 0, 0.02), 0px 2px 2px 0px rgba(0, 0, 0, 0.02), 0px 1px 1px 0px rgba(0, 0, 0, 0.02);
  justify-content: center;
}

.success-message {
  max-width: 20em;
  font-size: 1.25em;
}

.success-info {
  color: var(--stk-text-50);
}
</style>
